import React, { useState } from 'react';
import { getScreenName } from '../../../Utils/helper';
import {
  FloatInput,
  FloatLabelDiv,
} from '../ClinicListingPage/ClinicCallbackOption/styled';
import { validationHandler } from '../HealthPlan/common';
import { ErrorTextStyle } from '../HealthPlan/styled';
import { assessmentText } from '../../QnaPage/AssessmentStrip/instrumentation';
import { fireEvent } from '../../../Utils/fireEvent';

export default function MobileInputField(props) {
  const {
    element,
    inputFieldErrorHandler,
    index,
    inputFieldError,
    fromPdp,
    inAppForm,
  } = props;
  element['error_text'] = `Please Enter ${element?.question_text}`;
  const [userEnteredValue, setUserEnteredValue] = useState('');
  const handler = (event) => {
    let value = event.target.value;
    value = value.replace(/[^0-9]/gi, '');
    setUserEnteredValue(event.target.value);
    inputFieldErrorHandler(event.target.value, index);
  };
  const fireInputEvent = (event) => {
    if (!inAppForm)
      fireEvent({
        category: 'entered_mobile',
        screen_name: getScreenName(),
        sku_type: assessmentText,
        page_url: typeof window != 'undefined' ? window.location.href : 'NA',
        parent: assessmentText,
        value: event?.target.value,
      });
  };
  return (
    <FloatLabelDiv>
      <h2>{element.question_text}</h2>
      <FloatInput
        type="tel"
        autoFocus={index == 0 ? true : false}
        placeholder="Phone number* "
        id="contact"
        onChange={(event) => {
          handler(event);
        }}
        pattern="[1-9]{1}[0-9]{9}"
        maxLength="10"
        required={true}
        onBlur={(event) => {
          fireInputEvent(event);
        }}
        inputmode={'numeric'}
      />
      {/* <MobileFloatLabel htmlFor="" dynamic>
                Phone Number
            </MobileFloatLabel> */}
      <ErrorTextStyle>
        {!validationHandler(element?.validation_type, userEnteredValue) &&
        userEnteredValue != ''
          ? element?.error_text
          : null}
      </ErrorTextStyle>
    </FloatLabelDiv>
  );
}
